import React from 'react'
import { DialogContent, Typography } from '@mui/material'

const NonAppDownloadConfirmationModalContent = () => {
  return (
    <DialogContent>
      <Typography variant="body2" align="center">
        <>
          <strong>You’ll get an email</strong> when your rewards are ready to be claimed!
        </>
      </Typography>
    </DialogContent>
  )
}

export default NonAppDownloadConfirmationModalContent
